<template>
  <svg height="0" width="0">
    <defs>
      <clipPath :id="shape">
        <path
            id="a"
            d="M135.645184 350.722579c-50.7622075-83.697279-73.022702-147.7436-66.7814829-192.138964C75.1049203 114.188251 111.489703 77.7649496 178.01805 49.3137097l74.290461 8.1665312 82.442336 107.4446601-16.388025 152.304573-182.717638 33.493105z"
            transform="rotate(132 194.92548513 167.226642)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    shape: { type: String, required: true },
  },
};
</script>
